export default __webpack_public_path__ + "static/media/nodata.82155ef1.svg";